export const useAuthenticationState = defineStore('repo.authentication.state', () => {
    const authenticated = ref(false);
    const user = ref({});

    const {
        data,
        execute
    } = useApiFetchX('/account/user');

    callOnce(async () => {
        await execute();

        if (!data.value.isError && data.value.payload) {
            user.value = data.value.payload;
            authenticated.value = true
        }
    });

    return {
        authenticated,
        user
    };
})